import { createApp } from 'vue';
import store from '@/store';
import i18n, { setLocale } from '@/locales';
import { attempt, isError, mapValues } from '@utils';
import { registerIcons } from '@clicksign/ds-icons';

// Views
import HomePage from '@views/HomePage.vue';
import DocumentValidator from '@views/DocumentValidator.vue';
import ValidateAccess from '@views/ValidateAccess.vue';
import ValidateWithPassword from '@views/ValidateWithPassword.vue';
import RenewCertificate from '@views/RenewCertificate.vue';
import CadesSignature from '@views/CadesSignature.vue';

const VIEWS = {
  HomePage,
  DocumentValidator,
  ValidateAccess,
  ValidateWithPassword,
  RenewCertificate,
  CadesSignature,
};

const parseDatasetToProps = (dataset = {}) =>
  mapValues(dataset, (value) => {
    const isParsableString = !isError(attempt(JSON.parse.bind(null, value)));
    return isParsableString ? JSON.parse(value) : value;
  });

const layoutDataElement = document.getElementById('app');
const layoutData = layoutDataElement ? parseDatasetToProps(layoutDataElement.dataset) : {};

const element = document.getElementsByTagName('Vue')[0];
const props = parseDatasetToProps(element.dataset.props);
const view = VIEWS[element.dataset.view];

registerIcons();

setLocale(layoutData?.config?.locale);

const app = createApp(view, props);
app.use(store);
app.use(i18n);
app.mount(element);
